var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15523 2.83977L10.3286 5.18643C10.4886 5.5131 10.9152 5.82643 11.2752 5.88643L13.4019 6.23977C14.7619 6.46643 15.0819 7.4531 14.1019 8.42643L12.4486 10.0798C12.1686 10.3598 12.0152 10.8998 12.1019 11.2864L12.5752 13.3331C12.9486 14.9531 12.0886 15.5798 10.6552 14.7331L8.66189 13.5531C8.30189 13.3398 7.70856 13.3398 7.34189 13.5531L5.34856 14.7331C3.92189 15.5798 3.05523 14.9464 3.42856 13.3331L3.90189 11.2864C3.98856 10.8998 3.83523 10.3598 3.55523 10.0798L1.90189 8.42643C0.928559 7.4531 1.24189 6.46643 2.60189 6.23977L4.72856 5.88643C5.08189 5.82643 5.50856 5.5131 5.66856 5.18643L6.84189 2.83977C7.48189 1.56643 8.52189 1.56643 9.15523 2.83977Z",
    fill: "#234943"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2ab25a7c5ad87b10a10f5c2bba262542.svg";
export { ForwardRef as ReactComponent };